<template>
  <div class="analysisPublic">
    <!-- 头部 -->
    <!-- <Header>AnalysisPublic舆情分析</Header> -->
    <!-- 内容区 -->
    <!-- <div class="content">
      <div class="left">
        <div class="classify-box"></div>
        <div class="evaluation-box"></div>
      </div>
      <div class="center"></div>
      <div class="right"></div>
    </div> -->

    <router-link to="/Home" class="home"></router-link>
      <router-link to="/Home" class="exit"></router-link>
  </div>
</template>

<script>

//import Header from "../../components/Header.vue";
export default {
 // components: { Header },
  name: "AnalysisPublic", // 旅游舆情分析
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
.analysisPublic {
  width: 100vw;
  height: 100vh;
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
  // background-image: url("../../assets/image/analysis_bg.png");
   background-image: url("../../assets/image/test/analysis.jpg");
  .home{
    width: rpx(86);
    height: rpx(49);
    position:absolute;
    
    top: rpx(51);
    right: rpx(313);
  }
  .exit{
     width: rpx(86);
    height: rpx(49);
    position:absolute;

    top: rpx(51);
    right: rpx(20);
  }


  header {
    width: 100%;
    height: 10%;
  }
  .content {
    display: flex;
    justify-content: space-around;
    width: 100%;
    height: 90%;

    box-sizing: border-box;

    .left {
      display: flex;
      flex-direction: column;
      align-items: center;
      height: 100%;
      width: 24%;
   
      .classify-box {
        width: 96%;
        height: 49%;

        background-size: 100% 100%;
        background-position: center;
        background-repeat: no-repeat;
        background-image: url("../../assets/image/pic/border_light.png");
      }
      .evaluation-box {
        width: 96%;
        height: 49%;
        background-size: 100% 100%;
        background-position: center;
        background-repeat: no-repeat;
        background-image: url("../../assets/image/pic/border_light.png");
      }
    }
    .center {
      height: 100%;
      width: 52%;
      background-color: rgb(166, 190, 26);
    }
    .right {
      height: 100%;
      width: 24%;
      
    }
  }
}
</style>